import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const BillableSVG = ({
  fill = '#BCBEC2',
  size = '16',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 1000 1000"
      {...otherSvgProps}
    >
      <path
        fill={fill}
        d="M9.82 0H2.182C.98 0 .001.941.001 2.098V4.21c0 .386.325.7.727.7.401 0 .727-.314.727-.7V2.098c0-.386.327-.7.727-.7H9.82c.401 0 .727.314.727.7v9.913l-1.513-.947a.753.753 0 00-.794 0L6 12.466l-2.24-1.402a.751.751 0 00-.792 0l-1.514.947V6.594c0-.386-.325-.699-.727-.699-.401 0-.727.313-.727.7V13.3c0 .257.146.493.38.615a.75.75 0 00.744-.028l2.24-1.402 2.24 1.402a.747.747 0 00.792 0l2.24-1.402 2.24 1.402a.75.75 0 00.744.028.696.696 0 00.38-.614V2.098C12 .94 11.023 0 9.82 0z"
        transform="translate(500 500) scale(64.9351) translate(-6 -7)"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill={fill}
        d="M4.244 5.168l-2.51-.005C.7 5.114.3 4.316.273 3.792V2.97c.037-.828.784-1.315 1.41-1.348h.59c-.065-.446.224-.905.727-.9.504-.005.792.453.728.9h1.16c.951.005.95 1.395 0 1.399l-3.16-.004.001.755 2.558-.007c.667.035 1.387.497 1.427 1.37l.001.723c.059.557-.434 1.395-1.296 1.452h-.691c.152 1.215-1.606 1.216-1.455 0H1.22c-.952-.004-.952-1.395 0-1.399h3.023v-.743z"
        transform="translate(500 500) translate(-2.996 -4.472)"
        vectorEffect="non-scaling-stroke"
      ></path>
      <path
        fill={fill}
        d="M4.244 5.168l-2.51-.005C.7 5.114.3 4.316.273 3.792V2.97c.037-.828.784-1.315 1.41-1.348h.59c-.065-.446.224-.905.727-.9.504-.005.792.453.728.9h1.16c.951.005.95 1.395 0 1.399l-3.16-.004.001.755 2.558-.007c.667.035 1.387.497 1.427 1.37l.001.723c.059.557-.434 1.395-1.296 1.452h-.691c.152 1.215-1.606 1.216-1.455 0H1.22c-.952-.004-.952-1.395 0-1.399h3.023v-.743z"
        transform="translate(500 473.657) scale(52.7807) translate(-2.996 -4.472)"
        vectorEffect="non-scaling-stroke"
      ></path>
    </svg>
  </span>
);

export default BillableSVG;
